import {
  MY_WEB_NOTIFICATION_LIST,
  MY_WEB_NOTIFICATION_LIST_URGENT,
  GET_MY_WEB_NOTIFICATION,
} from '@/api/graphql/notifications'
import { apolloClient } from '@/plugins/apollo'

export default {
  async getMyWebNotification (context, { id }) {
    const got = await apolloClient.query({
      query: GET_MY_WEB_NOTIFICATION,
      variables: {
        id,
      }
    });
    return got.data.getMyWebNotification
  },
  async myWebNotificationList (context, { apollo, take, skip }) {
    return new Promise((resolve, reject) => {
      apollo.mutate({
        mutation: MY_WEB_NOTIFICATION_LIST,
        variables: {
          take: take,
          skip: skip,
          important: false
        }
      }).then(data => {
        context.commit('setNews', data.data.myWebNotificationList.items)
        resolve(data)
      }).catch(error => reject(error))
    })
  },
  async myWebNotificationListUrgent (context, { apollo, take, skip }) {
    return new Promise((resolve, reject) => {
      apollo.mutate({
        mutation: MY_WEB_NOTIFICATION_LIST_URGENT,
        variables: {
          take: take,
          skip: skip,
          important: true
        }
      }).then(data => {
        resolve(data)
      }).catch(error => reject(error))
    })
  }
}
